import { jsx as _jsx } from "react/jsx-runtime";
import { useAppSelector } from '../hooks';
import { Selector } from '../components/Selector';
export const TransmitterSelector = (props) => {
    const devices = useAppSelector(state => state.definitions.devices);
    const options = [];
    Object.values(devices).forEach(t => {
        if (t.transmitter_kind) {
            options.push({
                value: t.id,
                label: t.title
            });
        }
    });
    options.sort((a, b) => a.label.localeCompare(b.label));
    return _jsx(Selector, Object.assign({ options: options }, props));
};
